<template>
	<div class="alarm_box">
		<div class="search_box">
			<div class="box_line">
				<div class="line_input">
					<div class="input_title">记录时间</div>
					<el-date-picker
						size="small"
						v-model="searchDate"
						type="datetimerange"
						value-format="yyyy-MM-dd HH:mm:ss"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						style="width: 392px;"
					></el-date-picker>
				</div>
				<div class="search-btn" @click="fnSearchRecord"><span>搜索</span></div>
				<div class="search-btn orange" @click="fnSearchRecord"><span>刷新</span></div>
				<div class="title">
					<span>预报警记录</span>
					<svg-icon class="close" icon-class="close" @click="fnClose" />
				</div>
			</div>
		</div>
        <div class="cont_list">
            <div class="list_title">
                <div class="title_item">实时载重 (kg)</div>
                <div class="title_item">重量百分比 (%)</div>
                <div class="title_item">倾角X (°)</div>
                <div class="title_item">倾角X百分比 (%)</div>
                <div class="title_item">倾角Y (°)</div>
                <div class="title_item">倾角Y百分比 (%)</div>
                <div class="title_item">锂电池电压 (V)</div>
                <div class="title_item">设备状态</div>
                <div class="title_item">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.realTimeLoad}}</div>
                            <div class="list_item">{{ item.weightPercentage }}</div>
                            <div class="list_item">{{ item.tiltX }}</div>
                            <div class="list_item">{{ item.tiltXPercentage}}</div>
                            <div class="list_item">{{ item.tiltY }}</div>
                            <div class="list_item">{{ item.tiltYPercentage }}</div>
                            <div class="list_item">{{ item.lithiumBatteryVoltage}}</div>
                            <div class="list_item" :title="fnUnloadingStatusToText(item.status).text">
                                <span v-if="fnUnloadingStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnUnloadingStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnUnloadingStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item" :title="item.record_at">
                                <span>{{ item.record_at ? item.record_at : '无' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<div class="cont_page">
			<el-pagination
				class="pagination"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pageTotal"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request';
import APP from '@/utils/base';

export default {
	props: {
		currentUnloading: {
			type: Object
		}
	},
	data() {
		return {
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			searchDate: null,
			tableData: [],
			currentUnloadingNew: {
				eqptStatus: '',
				number: '',
				nowTime: ''
			}
		};
	},
	created() {
		this.fnInit();
	},
	watch: {
		currentUnloading: {
			handler: function(newV, oldV) {
				if (oldV && newV) {
					if(newV.nowTime >= oldV.nowTime){
						this.fnInit();
					}
				}
				if (newV === undefined) {
					this.currentUnloadingNew = {
						eqptStatus: '',
						number: '',
						nowTime: ''
					}
				} else {
					this.currentUnloadingNew.eqptStatus = newV.eqptStatus;
					this.currentUnloadingNew.number = newV.number;
					this.currentUnloadingNew.nowTime = newV.nowTime;
					this.fnInit();
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		// 更改分页内容
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearchRecord();
		},
		// 翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			if (!(this.currentUnloadingNew && this.currentUnloadingNew.number)) return;
			this.fnGetUnloadingRecord(
				{
					number: this.currentUnloadingNew.number,
					is_alarm: APP.YES,
					create_at: this.searchDate ? this.searchDate.join(',') : '',
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 初始化
		fnInit() {
			if (!(this.currentUnloadingNew && this.currentUnloadingNew.number)) return;
			this.currentPage = APP.PAGE.SKIP_PAGE;
			this.pageSize = APP.PAGE.LIMIT;
			this.fnGetUnloadingRecord(
				{
					number: this.currentUnloadingNew.number,
					is_alarm: APP.YES,
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 获取升降机装载记录
		fnGetUnloadingRecord(_obj, _cb) {
			request({
				url: 'unloading/getRecord',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res.data);
				})
				.catch(err => {
					this.tableData = [];
					this.pageTotal = 0;
				});
		},
		// 搜索升降机吊装记录
		fnSearchRecord() {
			this.currentPage = APP.PAGE.SKIP_PAGE;
			if (!(this.currentUnloadingNew && this.currentUnloadingNew.number)) return;
			this.fnGetUnloadingRecord(
				{
					number: this.currentUnloadingNew.number,
					is_alarm: APP.YES,
					create_at: this.searchDate ? this.searchDate.join(',') : '',
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 升降机运行状态
		fnUnloadingStatusToText(_status) {
			return APP.fnCraneStatusToText(_status, 'unloading');
		},
		// 关闭当前组件
		fnClose() {
			this.$parent.fnOpenHome();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.alarm_box_box {
	width: 1600px;
	height: 778px;
}
.search_box {
	height: 40px;
	width: 1600px;
	margin-bottom: 10px;
	@include flex-box(center, center);
	.box_line {
		width: 1580px;
		height: 32px;
		position: relative;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
		}
		.title {
			position: absolute;
			right: 20px;
			@include flex-box(center, center);
			span {
				color: #cf9236;
				font-size: 24px;
				margin-right: 20px;
			}
		}
	}
}
.cont_list {
	width: 1580px;
	margin: 0 10px;
	height: 660px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1580px;
		height: 48px;
		background: url(../../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			text-align: center;
			@include flex-box(center, center);
                &:nth-child(1) {
                    width: 160px;
                    margin: 0 2px 0 20px;
                }

                &:nth-child(2) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(3) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(4) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(5) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(6) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(7) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(8) {
                    width: 160px;
                    margin: 0 2px;
                }

                &:nth-child(9) {
                    width: 300px;
                    margin-left: 2px;
                }
		}
	}
	.list_boxes {
		width: 1540px;
		margin-left: 20px;
		height: 612px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1540px;
				height: 70px;
				margin-top: 5px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					@include flex-box(center, center);
                        &:nth-child(1) {
                            width: 160px;
                            margin-right: 2px;
                        }

                        &:nth-child(2) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(3) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(4) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(5) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(6) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(7) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(8) {
                            width: 160px;
                            margin: 0 2px;
                        }

                        &:nth-child(9) {
                            width: 300px;
                            margin-left: 2px;
                        }
				}
			}
		}
	}
}
.cont_page {
	width: 1564px;
	height: 30px;
	margin-left: 21px;
	margin-top: 30px;
	>>> .el-pagination__total {
		color: #439fe3;
		font-size: 14px !important;
	}
	>>> .el-input__inner {
		background-color: rgba(49, 88, 128, 0.5) !important;
		border: none !important;
		color: #439fe3 !important;
	}
	>>> .el-pagination__jump {
		color: #439fe3;
		font-size: 14px !important;
	}
	>>> .el-select__caret {
		color: #439fe3;
	}
	>>> .el-pagination.is-background .btn-prev {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}
	>>> .el-pagination.is-background .btn-prev:disabled {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}
	>>> .el-pagination.is-background .btn-next {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}
	>>> .el-pagination.is-background .btn-next:disabled {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}
	>>> .el-pagination.is-background .el-pager li {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}
	>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #50aaff !important;
		color: #091027;
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Unloading/unloadingDefault/components/Alarm.vue